import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {BookingSummaryComponent} from './booking-summary.component';
import {InputTextModule} from 'primeng/inputtext';
import {MultiSelectModule} from 'primeng/multiselect';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {SelectButtonModule} from 'primeng/selectbutton';
import {RouterModule} from '@angular/router';
import {ToastModule} from 'primeng/toast';
import {CalendarModule} from 'primeng/calendar';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {DialogModule} from 'primeng/dialog';
import {ChipModule} from 'primeng/chip';
import {DropdownModule} from 'primeng/dropdown';
import {MenuModule} from 'primeng/menu';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {RadioButtonModule} from 'primeng/radiobutton';
import {FileUploadModule} from 'primeng/fileupload';
import {BookingsFilterComponent} from './bookings-filter/bookings-filter.component';
import {PaginatorModule} from "primeng/paginator";
import {BadgeModule} from 'primeng/badge';
import {AvatarModule} from "primeng/avatar";
import { BookingSummaryMobileComponent } from './booking-summary-mobile/booking-summary-mobile.component';
import {TabViewModule} from "primeng/tabview";
import { BookingSummaryTabletComponent } from './booking-summary-tablet/booking-summary-tablet.component';
import {ConfirmationService} from "primeng/api";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import { ShipmentDetailsAndTrackingComponent } from './shipment-details-and-tracking/shipment-details-and-tracking.component';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import { ShipmentDetailsComponent } from './shipment-details-and-tracking/shipment-details/shipment-details.component';
import { ShipmentTrackingComponent } from './shipment-details-and-tracking/shipment-tracking/shipment-tracking.component';
import {TimelineModule} from 'primeng/timeline';
import {CardModule} from 'primeng/card';


@NgModule({
    declarations: [BookingSummaryComponent, BookingsFilterComponent, BookingSummaryMobileComponent, BookingSummaryTabletComponent, ShipmentDetailsAndTrackingComponent, ShipmentDetailsComponent, ShipmentTrackingComponent],
    imports: [
        CommonModule,
        InputTextModule,
        MultiSelectModule,
        FormsModule,
        TableModule,
        ButtonModule,
        RippleModule,
        SelectButtonModule,
        RouterModule,
        ToastModule,
        ReactiveFormsModule,
        CalendarModule,
        AutoCompleteModule,
        DialogModule,
        ChipModule,
        DropdownModule,
        MenuModule,
        InputNumberModule,
        InputTextareaModule,
        RadioButtonModule,
        FileUploadModule,
        PaginatorModule,
        BadgeModule,
        AvatarModule,
        TabViewModule,
        ConfirmDialogModule,
        BreadcrumbModule,
        TimelineModule,
        CardModule
    ], providers: [DatePipe, ConfirmationService]
})
export class BookingSummaryModule {
}
